module.exports = __webpack_public_path__ + "static/img/153_TO8_1871.bae1b44.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/153_TO8_1871.jpg
// module id = jVCk
// module chunks = 0